import { z } from "zod";

/** Represents the enum public.recipient_type */
type RecipientType = "email" | "sms" | "push";

export default RecipientType;

/** Zod schema for recipient_type */
export const recipientType = z.enum(["email", "sms", "push"]);
